<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="save()"
  >
    <page-template>
      <template slot="title">
        <page-title
          v-if="pageTitle"
          :title="pageTitle"
          :navigate-back-route="navigateBackRoute"
        />
      </template>
      <template slot="content">
        <v-container
          class="py-0"
          fluid
          grid-list-sm
        >
          <div>
            <form-group>
              <v-flex
                xs12
                md12
                lg12
              >
                <v-layout>
                  <v-flex
                    xs12
                    md6
                    lg6
                  >
                    <input-percentage
                      v-model="payload.taxa"
                      label="Taxa"
                      :rules="[requiredRule]"
                      :decimals="2"
                      :loading="loadingForm"
                      required
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    md6
                    lg6
                  >
                    <input-select
                      v-model="payload.tipo"
                      label="Tipo da taxa"
                      :rules="[requiredRule]"
                      :items="types"
                      :return-object="false"
                      item-text="label"
                      item-value="value"
                      :loading="loadingForm"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex
                    xs12
                    md12
                    lg12
                  >
                    <input-text-area
                      v-model="payload.descricao"
                      label="Descrição"
                      :rules="[requiredRule]"
                      :loading="loadingForm"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <h3>Clientes no grupo</h3>
                </v-layout>
                <v-layout>
                  <v-flex
                    xs12
                    md10
                    lg10
                  >
                    <input-text-area
                      v-model="clientsIds"
                      label="Adicionar lista de ID's de clientes"
                      :rules="[onlyNumbersCommaSpace]"
                    />
                  </v-flex>
                </v-layout>
                <v-layout
                  v-if="isEdit"
                  class="custom-scroll"
                >
                  <v-flex v-if="loading">
                    <v-layout>
                      <v-flex
                        xs12
                        md4
                        lg4
                      >
                        <input-text
                          label="Documento"
                          loading
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md7
                        lg7
                      >
                        <input-text
                          label="Cliente"
                          loading
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md1
                        lg1
                      >
                        <v-btn
                          icon
                          color="primary"
                          loading
                        >
                          <v-icon>
                            mdi-minus
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-else-if="hasClients">
                    <v-layout
                      v-for="(client, idx) in clients"
                      :key="client.cpfCnpj"
                    >
                      <v-flex
                        xs12
                        md4
                        lg4
                      >
                        <input-text
                          label="Documento"
                          :value="formatDocument(client.cpfCnpj)"
                          readonly
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md7
                        lg7
                      >
                        <input-text
                          label="Cliente"
                          :value="client.nome"
                          readonly
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        md1
                        lg1
                      >
                        <v-btn
                          icon
                          color="primary"
                          @click="remove(idx)"
                        >
                          <v-icon>
                            mdi-minus
                          </v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-else>
                    <p>Grupo não tem clientes vinculados</p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </form-group>
          </div>

          <v-flex
            class="py-3 text-xs-right"
          >
            <v-divider class="my-4" />
            <btn-cancel
              :text="$t('support.components.crudForm.btnCancel')"
              @click="navigateTo(navigateBackRoute)"
            />
            <btn-primary
              text="Salvar"
              :loading="loading"
              type="submit"
            />
          </v-flex>
        </v-container>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import TaxGroupRequest from 'Domain/tax-group/TaxGroupRequest';
import FormGroup from 'Support/layout/FormGroup.vue';
import InputPercentage from 'Support/components/inputs/InputPercentage.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import rulesMixin from 'Support/mixins/rules-mixin';
import InputTextArea from 'Support/components/inputs/InputTextArea.vue';
import notificationMixin from 'Support/mixins/notification-mixin';
import formatCpf from 'Support/filters/formatCpf';
import formatCnpj from 'Support/filters/formatCnpj';
import InputText from 'Support/components/inputs/InputText.vue';
import formMixin from 'Support/components/crud/form-mixin';
import routerMixin from 'Support/mixins/router-mixin';
import PageTemplate from 'Support/layout/PageTemplate.vue';
import PageTitle from 'Support/layout/PageTitle.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import BtnCancel from 'Support/components/buttons/BtnCancel.vue';
import taxGroupTypes from '../taxManagerTypes';

export default
{
  name: 'TaxGroupForm',
  components: {
    FormGroup,
    InputPercentage,
    InputSelect,
    InputTextArea,
    InputText,
    PageTemplate,
    PageTitle,
    BtnPrimary,
    BtnCancel,
  },
  mixins: [rulesMixin, notificationMixin, formMixin, routerMixin],
  data() {
    return {
      requestClass: TaxGroupRequest,
      payload: {
        descricao: '',
        taxa: '',
        tipo: '',
      },
      types: taxGroupTypes,
      clients: [],
      loading: false,
      loadingForm: false,
      clientsIds: '',
    };
  },
  computed: {
    getId() {
      return Number(this.$route.params.id);
    },
    isEdit() {
      return this.getId > 0;
    },
    pageTitle() {
      return this.isEdit ? 'Editar controle de taxas por grupo' : 'Criar controle de taxas por grupo';
    },
    hasClients() {
      return Array.isArray(this.clients) && this.clients.length >= 1;
    },
    navigateBackRoute() {
      return 'taxGroup';
    },
    getClientsBody() {
      const clients = this.hasClients ? this.clients.map(
        client => client.id,
      ) : [];
      return {
        listaIds: [
          ...clients,
          ...this.clientsIds.split(',').map(Number),
        ].filter(Boolean),
      };
    },
  },
  created() {
    this.getClients();
  },
  methods: {
    preparePayload() {
      const { id: _, taxa, ...rest } = this.payload;
      return {
        ...rest,
        taxa: Number(taxa.replace(',', '.')),
      };
    },
    async getClients() {
      if (!this.isEdit) {
        return;
      }

      try {
        this.loading = true;
        const { data } = await this.requestClass.listClients(
          this.getId,
        );
        this.clients = data.content;
      } catch (err) {
        this.showErrorToast({
          title: 'Error',
          text: !err ? 'Falha ao buscar clientes' : err.response.data.message || err.response.statusText || err.message,
        });
      } finally {
        this.loading = false;
      }
    },
    formatDocument(doc) {
      if (String(doc).length === 11) {
        return formatCpf(doc);
      }
      return formatCnpj(doc);
    },
    remove(position) {
      this.clients.splice(
        position,
        1,
      );
    },
    async create() {
      try {
        this.loading = true;
        const { data } = await this.requestClass.save(
          this.overridePayload(),
        );
        await this.requestClass.saveClients(
          data.id,
          this.getClientsBody,
        );
        this.successSave();
      } catch (err) {
        this.showMessageError(err.response);
      } finally {
        this.loading = false;
      }
    },
    async update() {
      try {
        this.loading = true;
        await Promise.all([
          this.requestClass
            .edit(this.entityId, this.overridePayload()),
          this.requestClass.saveClients(
            this.entityId,
            this.getClientsBody,
          ),
        ]);
        await this.getClients();
        this.successSave();
      } catch (err) {
        console.log(err);
        this.showMessageError(err.response);
      } finally {
        this.loading = false;
      }
    },
    successSave() {
      if (this.showSuccessToastMessage) {
        this.showSuccessToast({
          text: this.successToasMessageCreate,
        });
      }
      this.afterSave();
    },
    overridePayload() {
      const { taxa, ...props } = this.payload;
      return {
        ...props,
        taxa: String(taxa).replace(',', '.'),
      };
    },
    async loadEntityForEdit() {
      try {
        this.loadingForm = true;
        const { data } = await this.requestClass
          .get(this.entityId);

        if (Array.isArray(data)) {
          this.setEntityData(data[0]);
        } else {
          this.setEntityData(data);
        }
      } catch (err) {
        this.showMessageError(err.response);
      } finally {
        this.loadingForm = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
